import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  tabs: {
    marginBottom: pxToRem(26),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginBottom: '2rem',
      },
      [layout.breakpoints.min.lg]: {
        marginBottom: pxToRem(24),
      },
    },
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  tabsContent: {
    selectors: {
      '> .ms-Stack': {
        padding: 0,
      },
    },
  },
  actionRequiredWrapper: {
    marginBottom: pxToRem(24),
    selectors: {
      ':empty': {
        display: 'none',
      },
    },
  },
});
